export default __webpack_public_path__ + "static/media/fv_intro.53e18efc.png";